module.exports = __webpack_public_path__ + "img/video-item.51a8d698.svg";